<nz-card class="rounded p-4" nzHoverable>
  <nz-skeleton *ngIf="loading" [nzLoading]="loading" [nzActive]="true"></nz-skeleton>
  <div *ngIf="!loading" class="d-flex flex-column">
    <h6>Whitelist or Referrer Acces API</h6>
    <span>
      The data below is a Whitelist or referrer list of IPs that are registered in order to use / access the Integration API
    </span>
  </div>
  <div *ngIf="!loading" class="mt-3">
    <nz-table #basicTable [nzData]="listIPAddress" [nzFrontPagination]="false" [nzScroll]="{ x: '1000px' }">
      <thead>
        <tr>
          <th style="width: 50px !important"></th>
          <th style="width: 350px !important">IP Address</th>
          <th style="width: 350px !important">Platform Name</th>
          <th>Added</th>
          <th style="width: 100px !important"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let items of listIPAddress; let i = index">
          <td>{{ i + 1 }}</td>
          <td>{{ items.ip_address }}</td>
          <td>{{ items.platform_name }}</td>
          <td>{{ items.updated_at | date : "dd/MM/yyyy" }}</td>
          <td>
            <button class="btn p-0" (click)="deleteReferrer(items.id, '')">
              <img
                src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/trash.svg"
                alt="delete"
                width="20px"
              />
            </button>
          </td>
        </tr>
      </tbody>
    </nz-table>
    <div class="mt-3">
      <button class="btn btn-primary text-white" (click)="addReferrer()">
        Add Referrer
      </button>
    </div>
  </div>
</nz-card>
